import Bouncer from 'formbouncerjs';

export default new class Validation {
  constructor() {
    this.formForValidationSelector = '._required';
    this.inValidSelector = '_invalid';
    this.handler();

    this.mesages = {
      'first_name': 'Укажите ваше имя',
      'last_name': 'Укажите вашу фамилию',
      'phone': 'Укажите ваш номер телефона',
      'date_of_birth': 'Укажите вашу дату рождения'
    }
  }

  handler() {
    document.addEventListener('DOMContentLoaded', () => {
      this.validate(this.formForValidationSelector);
    });
  }

  validate(selector) {
    const self = this;
    this.validation = new Bouncer(selector, {
      fieldClass: 'validation-error',
      errorClass: 'validation-error__message',
      fieldPrefix: 'validation-error-',
      errorPrefix: 'validation-error-',
      messageAfterField: true,
      messageCustom: 'data-bouncer-message',
      messageTarget: 'data-bouncer-target',
      disableSubmit: true,
      messages: {
        missingValue: {
          checkbox: 'Это поле обязательно для заполнению.',
          radio: 'Пожалуйста, выберите значение.',
          select: 'Пожалуйста, выберите значение.',
          'select-multiple': 'Выберите хотя бы одно значение.',
          default: function (field) {
            const sField = field.name;
            const sMessage = self.mesages[sField];
            if (!field.value && sMessage) {
              return sMessage;
            }

            return 'Пожалуйста, заполните это поле.';
          }
        },
        patternMismatch: {
          email: 'Пожалуйста, введите действительный адрес электронной почты.',
          url: 'Пожалуйста, введите URL.',
          number: 'Пожалуйста, введите URL.',
          color: 'Пожалуйста, соответствуйте следующему формату: #rrggbb',
          date: 'Пожалуйста, используйте YYYY-MM-DD формат',
          time: 'Пожалуйста, используйте 24-часовой формат времени. Пример. 23:00',
          month: 'Пожалуйста, используйте YYYY-MM формат',
          default: 'Пожалуйста, заполните это поле.'
        },
        outOfRange: {
          over: 'Пожалуйста, выберите значение не более {max}.',
          under: 'Пожалуйста, выберите значение не меньше, чем {min}.'
        },
        wrongLength: {
          over: 'Сократите этот текст до символов, не превышающих {maxLength}. В настоящее время вы используете {length} символов.',
          under: 'Увеличьте длину этого текста до {minLength} символов или более. В настоящее время вы используете {length} символов.'
        }

      },
    });

    document.addEventListener('bouncerFormValid', ({ target }) => {
      target.classList.remove(this.inValidSelector);
    });

    document.addEventListener('bouncerFormInvalid', ({ target }) => {
      target.classList.add(this.inValidSelector);
    });
  }
}();
